module.exports = __webpack_public_path__ + "img/buttonArrow.6c8aedc5.svg";